/* Little Boudoir — « Complétez le cadeau » : ajout multi-lignes 100% thème.
   Ajoute les articles cochés en une seule requête /cart/add.js, rafraîchit le
   drawer + la pastille panier (Bundled Section Rendering), et ouvre le drawer.
   La VRAIE réduction vient d'une remise automatique admin ; l'économie affichée
   ici est cosmétique (à aligner sur la remise — voir BUNDLES.md). */
if (!customElements.get('lb-bought-together')) {
  customElements.define(
    'lb-bought-together',
    class LbBoughtTogether extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-bt-add]');
        this.totalEl = this.querySelector('[data-bt-total]');
        this.countEl = this.querySelector('[data-bt-count]');
        this.errorEl = this.querySelector('[data-bt-error]');
        this.boxes = Array.from(this.querySelectorAll('input[data-bt-item]'));
        this.boxes.forEach((cb) => cb.addEventListener('change', () => this.updateTotal()));
        if (this.button) this.button.addEventListener('click', (e) => this.addSelected(e));
        this.updateTotal();
      }

      selected() {
        return this.boxes.filter((cb) => cb.checked);
      }

      money(cents) {
        try {
          var cur = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'EUR';
          return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: cur });
        } catch (e) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }
      }

      updateTotal() {
        var cents = 0;
        var sel = this.selected();
        sel.forEach((cb) => (cents += parseInt(cb.dataset.price || '0', 10)));
        if (this.totalEl) this.totalEl.textContent = this.money(cents);
        if (this.countEl) this.countEl.textContent = sel.length;
        if (this.button) this.button.disabled = sel.length === 0;
      }

      async addSelected(e) {
        if (e) e.preventDefault();
        var sel = this.selected();
        if (!sel.length) return;
        var items = sel.map((cb) => {
          var it = { id: parseInt(cb.dataset.variant, 10), quantity: 1 };
          /* Trace le niveau qui a produit la suggestion (n1 choisi à la main, n2 même créateur,
             n3 collection, n4 filet) : la propriété apparaît sur la commande, ce qui permet de
             savoir quelle règle vend réellement, sans outil d'analyse. Masquée au client. */
          var props = {};
          if (cb.dataset.coffret) props._coffret = cb.dataset.coffret;
          if (cb.dataset.complement) props._complement = cb.dataset.complement;
          if (Object.keys(props).length) it.properties = props;
          return it;
        });
        if (this.errorEl) this.errorEl.hidden = true;
        /* Un second clic pendant la requête ajouterait tout une deuxième fois : le bouton
           est désactivé jusqu'à la réponse, et un verrou couvre le double-clic rapide. */
        if (this.busy) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        this.button.setAttribute('aria-busy', 'true');
        var ajoute = false;
        try {
          var res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: items,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          var data = await res.json();
          if (res.status !== 200) {
            this.showError(data.description || data.message || 'Ajout impossible.');
            return;
          }
          ajoute = true;
          /* Les articles sont au panier : on décoche, sinon un nouveau clic les rajouterait. */
          sel.forEach((cb) => (cb.checked = false));
          this.refresh(data);
        } catch (err) {
          this.showError('Une erreur est survenue, réessayez.');
        } finally {
          this.busy = false;
          this.button.classList.remove('is-loading');
          this.button.removeAttribute('aria-busy');
          /* updateTotal recalcule l'état du bouton : désactivé s'il ne reste rien de coché. */
          this.updateTotal();
          if (!ajoute && this.selected().length) this.button.disabled = false;
        }
      }

      refresh(data) {
        var sections = data.sections || {};
        // Pastille panier
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var bInner = b.querySelector('#cart-icon-bubble') || b.querySelector('.shopify-section');
          if (bInner) bubble.innerHTML = bInner.innerHTML;
        }
        // Drawer
        var drawer = document.querySelector('cart-drawer');
        var replaced = false;
        if (drawer && sections['cart-drawer']) {
          var d = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newInner = d.querySelector('.drawer__inner');
          var curInner = drawer.querySelector('.drawer__inner');
          if (newInner && curInner) {
            curInner.replaceWith(newInner);
            drawer.classList.remove('is-empty');
            replaced = true;
          }
        }
        if (drawer && replaced && typeof drawer.open === 'function') {
          drawer.open(this.button);
        } else if (!drawer) {
          // Pas de drawer (cart_type page) : aller au panier
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        // Cohérence Dawn
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lb-bought-together' });
          } catch (e) {}
        }
      }

      showError(msg) {
        if (this.errorEl) {
          this.errorEl.textContent = msg;
          this.errorEl.hidden = false;
        }
      }
    }
  );
}
